import React from "react";
import './style.scss';
import OutlineButton from "../../../../../../components/OutlineButton/OutlineButton";
import { convertToHex } from "../../../../../../helpers/renderers";
import useIsMobile from "../../../../../../hooks/useIsMobile";
import SButton from "../../../../../../components/SButton/SButton";

const AccessPoint = ({ readerDetails, onRemove }) => {

    const isMobile = useIsMobile();

    return (
        <div className="ap-container">
            <div className="ap-inner-container">
                <p className="ap-name">{readerDetails?.accessPoint}</p>
                <p className="ap-version">{convertToHex(readerDetails?.firmwareVersion)}</p>
            </div>
            <SButton style={{ padding: '0.4rem 0.7rem' }} variant={"secondary"} color={"error"} onClick={() => { onRemove(readerDetails?.id) }} >Remove</SButton>
            {/* <OutlineButton style={{ color: '#FF0101', border: '1px solid #FF0101', width: isMobile ? '4rem' : '6rem' }} shadow={false} text="Remove" onClick={() => { onRemove(readerDetails?.id) }} /> */}
        </div>
    )
};

export default AccessPoint;